import React, { useState, useEffect } from "react";
import { descending, add_circle, edit, trash_can } from "../assets";
import { getContacts } from "../constants";
import { IoMdSearch } from "react-icons/io";
import { MdOutlineFileUpload, MdOutlineFileDownload } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { deleteContact } from "../constants";
import { ToastContainer, toast } from "react-toastify";
import ModalUploadContacts from "./modals/ModalUploadContacts";
import ModalDownloadContacts from "./modals/ModalDownloadContacts";
import ModalShowContact from "./modals/ModalShowContact";
import ModalDelete from "./modals/ModalDelete";

const Contacts_ = ({ token }) => {
  const [data, setData] = useState([]);
  const [dataContact, setDataContact] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [queryName, setQueryName] = useState("Name");
  const [queryValue, setQUeryValue] = useState("");
  const [urlTemplate, setUrlTemplate] = useState("");
  const columns = ["Name", "Company", "Job Title", "Card"];
  const [dataShow, setDataShow] = useState(null);

  useEffect(() => {
    getContacts(token, setData, setUrlTemplate);
  }, []);

  useEffect(() => {
    if (data.length > 0 && data[0].is_checked == undefined) {
      setData(
        data.map((v) => {
          return { ...v, is_checked: false };
        }),
      );
    }
  }, [data]);

  useEffect(() => {
    const msg = localStorage.getItem("toastMsg", "");
    if (Boolean(msg)) {
      // localStorage.removeItem("toastMsg");
      toast.success(msg, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          localStorage.removeItem("toastMsg");
        },
      });
    }
  }, []);

  useEffect(() => {
    if (isCheckedAll) {
      setData(
        data.map((val) => {
          return { ...val, is_checked: true };
        }),
      );
      setSelectedData(["*"]);
    } else {
      setSelectedData(
        data.filter((val) => val.is_checked).map((val) => val.contact_id),
      );
    }
  }, [isCheckedAll]);

  useEffect(() => {
    getContacts(token, setData, setUrlTemplate, queryName, queryValue);
  }, [queryValue, queryName]);

  return (
    <div className="flex flex-col flex-1 bg-white overflow-y-auto w-full px-7 pb-40 md:py-5 md:pb-40 gap-10 md:gap-5">
      <ToastContainer />
      <div className="flex flex-col-reverse md:flex-row w-full justify-between items-center gap-2 md:gap-0">
        <div className="flex flex-row gap-3 w-full md:w-fit">
          <select
            id="columns"
            className="bg-white border border-gray-400 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-fit md:w-full px-5 pl-3 pr-12"
            value={queryName}
            onChange={(e) => setQueryName(e.target.value)}
          >
            {columns.length > 0 ? (
              columns.map((val, ind) => (
                <option key={ind} value={val.replace(" ", "_").toLowerCase()}>
                  {val}
                </option>
              ))
            ) : (
              <option>Column</option>
            )}
          </select>
          <div className="flex flex-row border rounded-lg px-3 py-2 items-center w-full">
            <input
              type="text"
              name="Search"
              placeholder="Search"
              className="w-full focus:outline-none"
              value={queryValue}
              onChange={(e) => {
                e.preventDefault();
                setQUeryValue(e.target.value);
              }}
            />
            <IoMdSearch className="text-[24px] cursor-pointer rounded-full hover:bg-gray-100 p-1" />
          </div>
        </div>
        <div className="flex flex-row gap-2 items-start md:items-center w-full md:w-fit">
          <div
            onClick={(e) => {
              document.getElementById("upload_contacts_modal").showModal();
            }}
            className="flex flex-row gap-1 items-center rounded-lg border hover:bg-gray-200 cursor-pointer py-2 px-5"
          >
            <MdOutlineFileUpload className="text-[20px] text-black" />
            <div className="hidden md:flex">Upload</div>
          </div>
          <div
            onClick={(e) => {
              document.getElementById("download_contacts_modal").showModal();
            }}
            className="flex flex-row gap-1 items-center rounded-lg border hover:bg-gray-200 cursor-pointer py-2 px-5"
          >
            <MdOutlineFileDownload className="text-[20px] text-black" />
            <div className="hidden md:flex">Download</div>
          </div>
          <div
            className="flex flex-row gap-1 items-center rounded-lg bg-primary hover:bg-tertiary text-white cursor-pointer py-2 px-5 w-full md:w-fit justify-center"
            onClick={(e) => {
              e.preventDefault();
              navigate("/contacts/create");
            }}
          >
            <div>Add contact</div>
          </div>
        </div>
      </div>
      <div className="w-full overflow-x-auto border border-primary rounded-lg">
        <table className="w-full text-left border-collapse">
          <thead className="border-b border-primary bg-white">
            <tr className="divide-x-2 divide-gray-300">
              <th className="p-2 w-fit">
                <input
                  type="checkbox"
                  name="all"
                  checked={isCheckedAll}
                  className="border border-primary rounded-lg"
                  onChange={(e) => {
                    setIsCheckedAll(!isCheckedAll);
                  }}
                />
              </th>
              {["Name", "Company", "Job Title", "Card", "Action"].map(
                (header) => (
                  <th
                    key={header}
                    className="p-2 font-bold text-black whitespace-nowrap"
                  >
                    <div className="flex items-center justify-between gap-4 cursor-pointer">
                      {header} <img src={descending} alt="" />
                    </div>
                  </th>
                ),
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.map((val, ind) => (
              <tr key={ind} className="hover:bg-gray-50">
                <td className="p-2 truncate">
                  <input
                    type="checkbox"
                    name={val.contact_id}
                    checked={val.is_checked}
                    className="border border-primary rounded-lg"
                    onChange={(e) => {
                      let d = [...data];
                      d[ind] = {
                        ...d[ind],
                        is_checked: !d[ind].is_checked,
                      };
                      setData(d);
                      if (!d[ind].is_checked) {
                        setIsCheckedAll(false);
                      } else {
                        setSelectedData(
                          d
                            .filter((val) => val.is_checked)
                            .map((val) => val.contact_id),
                        );
                      }
                    }}
                  />
                </td>
                <td
                  onClick={(e) => {
                    e.preventDefault();
                    setDataShow(val);
                    document.getElementById("contact_modal").showModal();
                  }}
                  className="p-2 truncate max-w-[150px] cursor-pointer hover:underline"
                >
                  {val.first_name} {val.last_name}
                </td>
                <td className="p-2 truncate max-w-[150px]">{val.company}</td>
                <td className="p-2 truncate max-w-[150px]">{val.job_title}</td>
                <td className="p-2 truncate">{val.user_card?.name}</td>
                <td className="p-2">
                  <div className="flex flex-row gap-2">
                    <div
                      className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
                      onClick={
                        data.length > 0
                          ? () => {
                              navigate("/contacts/update/" + val.contact_id);
                              // setCardData(cards[index]);
                              // setBreads([...breads, cards[index].card_name]);
                            }
                          : null
                      }
                    >
                      <img src={edit} alt="edit" className="w-[20px]" />
                    </div>
                    <div
                      className="cursor-pointer p-1 hover:bg-purple-100 rounded-lg"
                      onClick={
                        data.length > 0
                          ? () => {
                              setDataContact(val);
                              document
                                .getElementById("delete_modal")
                                .showModal();
                            }
                          : null
                      }
                    >
                      <img
                        src={trash_can}
                        alt="trash_can"
                        className="w-[20px]"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ModalDelete
        type={"contact"}
        data={dataContact}
        setFunc={deleteContact}
      />
      <ModalDownloadContacts
        selectedData={selectedData}
        queryName={queryName}
        queryValue={queryValue}
      />
      <ModalUploadContacts
        urlTemplate={urlTemplate}
        setData={setData}
        setUrlTemplate={setUrlTemplate}
      />
      <ModalShowContact data={dataShow} />
    </div>
  );
};

export default Contacts_;
